<template>
  <div class="container mt-5">
    <div class="mb-2">
      <md-card>
        <!-- <md-ripple> -->
        <md-card-header>
          <div class="md-title">Reportes Pendiendes</div>
          <div class="md-subhead">
            Ingresa la Fecha inicial y la Fecha final
          </div>
        </md-card-header>

        <md-card-content>
          <div class="row pl-5 pr-5">
            <div class="col">
              <!-- :class="errorClasses.inicial" -->
              <md-field>
                <md-icon><i class="fas fa-calendar-alt"></i></md-icon>
                <label class="md-required">Fecha incial</label>
                <md-input v-model="inicial" type="date"></md-input>
                <!-- <span v-if="errors.inicial" class="md-error">Campo requerido</span> -->
              </md-field>
            </div>
            <div class="col">
              <!-- :class="errorClasses.final" -->
              <md-field>
                <md-icon><i class="fas fa-calendar-alt"></i></md-icon>
                <label class="md-required">Fecha Final</label>
                <md-input v-model="final" type="date"></md-input>
                <!-- <span v-if="errors.final" class="md-error">Campo requerido</span> -->
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button
            class="col-2"
            style="background-color: #7890a8; color: #fff"
            @click="exportarExcel"
            v-if="reportesDownload"
          >
            <i class="fas fa-long-arrow-alt-down mr-2"></i>
            Descargar
          </md-button>
          <md-button
            class="col-2"
            style="background-color: #9cc4e4; color: #586875"
            @click="consultaReportes"
          >
            <i class="fas fa-search mr-2"></i>
            Buscar
          </md-button>
        </md-card-actions>
        <!-- </md-ripple> -->
      </md-card>
    </div>
    <div class="reportes-container">
      <div v-if="vistaTabla">
        <!-- Buscador -->
        <div class="p-3">
          <md-field>
            <label>Buscar reporte</label>
            <md-input
              v-model="busquedaReporte"
              @input="filtrarReportes"
              placeholder="Escribe cualquier término para buscar"
            ></md-input>
          </md-field>
        </div>

        <!-- Contenedor de la tabla con scroll -->
        <div class="tabla-scroll">
          <md-table
            v-model="paginatedReports"
            md-sort="Nombre"
            md-sort-order="asc"
            md-card
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              :class="{ 'text-danger': !item.Autorizado }"
            >
              <md-table-cell md-label="Póliza" md-numeric>{{
                item.NumeroPoliza
              }}</md-table-cell>
              <md-table-cell md-label="Nombre" md-sort-by="Nombre">{{
                item.Nombre
              }}</md-table-cell>
              <md-table-cell
                md-label="Apellido Paterno"
                md-sort-by="Apellido Paterno"
                >{{ item.ApellidoPaterno }}</md-table-cell
              >
              <md-table-cell
                md-label="Apellido Materno"
                md-sort-by="Apellido Materno"
                >{{ item.ApellidoMaterno }}</md-table-cell
              >
              <md-table-cell md-label="Fecha Nacimiento">{{
                item.FechaNacimiento
              }}</md-table-cell>
              <md-table-cell md-label="Accidente" md-sort-by="Accidente">{{
                item.TipoAccidente
              }}</md-table-cell>
              <md-table-cell md-label="Lesión" md-sort-by="Lesión">{{
                item.TipoLesion
              }}</md-table-cell>
              <md-table-cell md-label="Cuerpo" md-sort-by="Cuerpo">{{
                item.ParteCuerpo
              }}</md-table-cell>
              <md-table-cell
                md-label="Fecha Ocurrido"
                md-sort-by="Fecha Ocurrido"
                >{{ item.FechaOcurrido }}</md-table-cell
              >
              <md-table-cell md-label="Hora Ocurrido">{{
                item.HoraOcurrido
              }}</md-table-cell>
              <md-table-cell md-label="Descripcion">{{
                item.DescripcionAccidente
              }}</md-table-cell>
              <md-table-cell md-label="Institución" md-sort-by="Institución">{{
                item.NombreInstitucion
              }}</md-table-cell>
              <md-table-cell md-label="Nivel" md-sort-by="Nivel">{{
                item.NivelEducativo
              }}</md-table-cell>
              <md-table-cell md-label="Hospital" md-sort-by="Hospital">{{
                item.Hospital
              }}</md-table-cell>
              <md-table-cell md-label="Parentesco">{{
                item.ParentescoContancto
              }}</md-table-cell>
              <md-table-cell md-label="Teléfono Acompañante">{{
                item.Contacto
              }}</md-table-cell>
              <md-table-cell md-label="Folio">{{
                item.NumeroFolioInnova
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <!-- Paginador -->
        <nav class="pagination-nav">
          <ul class="pagination">
            <li
              :class="{ disabled: currentPageReporte === 1 }"
              @click="changePageReporte('prev')"
            >
              <a href="javascript:void(0)">«</a>
            </li>
            <li
              v-for="page in totalPagesReporte"
              :key="page"
              :class="{ active: page === currentPageReporte }"
              @click="changePageReporte(page)"
            >
              <a href="javascript:void(0)">{{ page }}</a>
            </li>
            <li
              :class="{ disabled: currentPageReporte === totalPagesReporte }"
              @click="changePageReporte('next')"
            >
              <a href="javascript:void(0)">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <SuccessModal
      :showDialog="showSuccess"
      :mensaje="mensajeSuccess"
      :reloadPage="reloadPage"
    />
    <ErrorModal :showDialog="showError" :mensaje="mensajeError" />
    <AlertModal :showDialog="showAlert" :mensaje="mensajeAlert" />
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script>
import * as XLSX from "xlsx";

import SuccessModal from "./Modals/successModal.vue";
import ErrorModal from "./Modals/errorModal.vue";
import AlertModal from "./Modals/alertModal.vue";
import Loading from "./Tools/loading.vue";

export default {
  name: "TableSort",
  components: {
    Loading,
    SuccessModal,
    ErrorModal,
    AlertModal,
  },
  data: () => ({
    reportesDownload: false,
    isLoading: false,
    //Alertas
    showAlert: false,
    mensajeAlert: "",
    showError: false,
    mensajeError: "",
    showSuccess: false,
    mensajeSuccess: "",
    reloadPage: false,
    reportes: [],
    inicial: "",
    final: "",
    errors: {
      inicial: false,
      final: false,
    },
    busquedaReporte: "",
    catalogoFiltradoReportes: [],
    currentPageReporte: 1,
    itemsPerPageReporte: 50,
    vistaTabla: false,
  }),

  computed: {
    paginatedReports() {
      const startIndex =
        (this.currentPageReporte - 1) * this.itemsPerPageReporte;
      const endIndex = startIndex + this.itemsPerPageReporte;
      return this.catalogoFiltradoReportes.slice(startIndex, endIndex);
    },
    totalPagesReporte() {
      return Math.ceil(
        this.catalogoFiltradoReportes.length / this.itemsPerPageReporte
      );
    },
  },
  watch: {
    reportes(newVal) {
      // Reinicia la tabla cuando los reportes cambien
      this.catalogoFiltradoReportes = [...newVal];
      this.currentPageReporte = 1;
    },
  },
  mounted() {
    // Inicializa la lista filtrada con todos los reportes
    this.catalogoFiltradoReportes = [...this.reportes];
  },
  methods: {
    async consultaReportes() {
      this.vistaTabla = true;
      this.reportesDownload = false;
      this.reportes = [];
      if (this.inicial == "" || this.final == "") {
        this.showError = true;
        this.mensajeError = "La Fecha Inicial y la Fecha Final son requeridos.";
        setTimeout(() => {
          this.showError = false;
        }, 4000);
        return;
      }
      this.isLoading = true;
      const payload = {
        metodo: "REPORTESALTAISEP",
        data: {
          fechaInicial: this.formatFecha(this.inicial),
          fechaFinal: this.formatFecha(this.final),
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          if (res.length <= 0) {
            this.isLoading = false;
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
            return;
          }
          this.reportes = res;
          this.reportesDownload = true;
        } else {
          this.isLoading = false;
          this.showError = true;
          this.mensajeError = "Hubo un error al consultar los reportes.";
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      } catch (error) {
        //Fin try
        this.isLoading = false;
        console.log(error);
      }
      this.isLoading = false;
    },
    filtrarReportes() {
      const filtro = this.busquedaReporte.toLowerCase();
      this.catalogoFiltradoReportes = this.reportes.filter((reporte) => {
        return (
          reporte.NumeroPoliza.toString().toLowerCase().includes(filtro) ||
          reporte.Nombre.toLowerCase().includes(filtro) ||
          reporte.ApellidoPaterno.toLowerCase().includes(filtro) ||
          reporte.ApellidoMaterno.toLowerCase().includes(filtro) ||
          reporte.Hospital.toLowerCase().includes(filtro) ||
          reporte.NumeroFolioInnova.toLowerCase().includes(filtro)
        );
      });
      this.currentPageReporte = 1; // Reinicia la paginación al filtrar
    },
    changePageReporte(value) {
      if (value === "prev" && this.currentPageReporte > 1) {
        this.currentPageReporte--;
      } else if (
        value === "next" &&
        this.currentPageReporte < this.totalPagesReporte
      ) {
        this.currentPageReporte++;
      } else if (typeof value === "number") {
        this.currentPageReporte = value;
      }
    },
    exportarExcel() {
      const registrosModificados = this.reportes.map((registro) => {
        return {
          ...registro,
          Autorizado: registro.Autorizado ? "Sí" : "No",
        };
      });

      const ws = XLSX.utils.json_to_sheet(registrosModificados);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte ISEP");

      XLSX.writeFile(wb, "ReporteISEP.xls", { bookType: "xls" });
    },
    formatFecha(fecha) {
      const date = new Date(fecha);
      const dia = String(date.getUTCDate()).padStart(2, "0");
      const mes = String(date.getUTCMonth() + 1).padStart(2, "0"); // Los meses en JavaScript van de 0 a 11
      const anio = date.getUTCFullYear();

      return `${dia}/${mes}/${anio}`;
    },
  },
};
</script>

<style>
.md-field.md-has-value .md-required,
.md-field.md-is-focused .md-required {
  transform: translateY(-1.5em); /* Posición ajustada */
  font-size: 12px; /* Tamaño más pequeño para el label al estar activo */
}

.md-field .md-required {
  position: absolute; /* Coloca el label en una posición absoluta */
  top: -0.1em; /* Ajusta la posición hacia arriba */
  left: 0;
  font-size: 12px; /* Tamaño inicial más grande */
  transition: all 0.2s ease-in-out; /* Animación suave */
  pointer-events: none; /* Evita que el label interrumpa el clic en el input */
}
.text-danger {
  color: red;
}
.pagination-nav {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}

.pagination li {
  margin: 0 4px;
}

.pagination li a {
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #007bff;
  cursor: pointer;
}

.pagination li a:hover {
  background-color: #f2f2f2;
}

.pagination li.active a {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.pagination li.disabled a {
  color: #ccc;
  cursor: not-allowed;
}
.reportes-container {
  display: flex;
  flex-direction: column;
  height: 100%; /* Ajustar según el tamaño deseado */
}

.tabla-scroll {
  overflow-y: auto; /* Habilita el desplazamiento vertical */
  max-height: 400px; /* Ajusta la altura máxima para tu diseño */
  border: 1px solid #ddd; /* Borde opcional para destacar el área */
  border-radius: 4px; /* Esquinas redondeadas */
}
</style>
